import { render, staticRenderFns } from "./ProfileFollowers.vue?vue&type=template&id=dffeb7f0"
import script from "./ProfileFollowers.vue?vue&type=script&lang=js"
export * from "./ProfileFollowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports